export const isWindow = (): boolean => typeof window !== 'undefined';
